import { GridSortItem } from '@mui/x-data-grid/models/gridSortModel';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IObject } from '../interfaces/IObject';

interface TatState {
  filters: IObject;
  sorting: GridSortItem[];
  pageNumber: number;
  refreshKey: number;
}

const initialState: TatState = {
  filters: {
    contract_type: null,
    contract_category: null,
    designation_users: null,
    designation_id: null,
    name: null,
  },
  sorting: [],
  pageNumber: 0,
  refreshKey: 0,
};

const tatSlice = createSlice({
  name: 'tat',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<IObject>) => {
      state.filters = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortItem[]>) => {
      state.sorting = action.payload;
    },
    setPageNumber: (state, action: PayloadAction<number>) => {
      state.pageNumber = action.payload;
    },
    setRefreshKey: (state, action: PayloadAction<number>) => {
      state.refreshKey = action.payload;
    },
  },
});

export const { setFilters, setSorting, setPageNumber, setRefreshKey } =
  tatSlice.actions;

export default tatSlice.reducer;
